import axios from 'axios';
import { API_URL } from '../config';
import { Contract, CCNL } from '../types';
import { transformPayload } from './utils';
import { AxiosRequestConfig } from 'axios';
interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  permission?: string;
}


const transformContractPayload = (contract: any) => {
  const propsToChange: Record<string, string> = {
    'classification_level': 'classification_level_id',
    'qualification': 'qualification_id',
    'social_security_institution': 'social_security_institution_id',
    'typology': 'typology_id',
    'working_hours_type': 'working_hours_type_id',
    'ccnl': 'ccnl_id',
  };

  transformPayload(contract, propsToChange);
};

export const getCCNLList = async (token: string, q: string | null): Promise<CCNL[]> => {
  const params: Record<string, any> = {};

  if(q)
    params['q'] = q;

  const response = await axios.get(`${API_URL}/presenze/resources/ccnl/?${new URLSearchParams(params).toString()}`, {
    headers: {
      'Authorization': token,
    }
  });
  return response.data;
};

export const getContractTypesList = async (token: string) => {
    const response = await axios.get(`${API_URL}/presenze/contract-types/`, {
      headers: {
        'Authorization': token,
      }
    });
    return response.data;
  };
  
  export const getEmployeeContractsList = async (token: string, id: string | number, permission: string | null): Promise<Contract[]> => {
    const response = await axios.get(`${API_URL}/presenze/employee/${id}/contracts/`, {
      headers: {
        'Authorization': token,
      },
      permission,
    } as CustomAxiosRequestConfig);
    return response.data;
  };
  
  export const addEmployeeContract = async (token: string, id: string | number, contract: any) => {
    transformContractPayload(contract)
    const response = await axios.post(`${API_URL}/presenze/employee/${id}/contracts/`,
      contract,
      {
        headers: {
          'Authorization': `${token}` 
        }
      });
    return response.data; 
  }
  
  export const updateEmployeeContract = async (token: string, employee_id: string | number, contract_id: string | number, updatedContractData: any) => {
    transformContractPayload(updatedContractData)
    const response = await axios.put(`${API_URL}/presenze/employee/${employee_id}/contracts/${contract_id}/`,
      updatedContractData,
      {
        headers: {
          'Authorization': `${token}` 
        }
      }
    );
    return response.data;
  }
  
  export const deleteEmployeeContract = async (token: string, employee_id: string | number, contract_id: string) => {
    const response = await axios.delete(`${API_URL}/presenze/employee/${employee_id}/contracts/${contract_id}/`,
      {
        headers: {
          'Authorization': `${token}` 
        }
      }
    );
    return response.data;
  }